/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Hour } from '../../models/hour';
import { LiveOccupancy } from '../../models/live-occupancy';

export interface GetStationCurrentOccupancy$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
  
    /**
     * the targeted hour window on the current day
     */
    body: Hour
}

export function getStationCurrentOccupancy(http: HttpClient, rootUrl: string, params: GetStationCurrentOccupancy$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveOccupancy>> {
  const rb = new RequestBuilder(rootUrl, getStationCurrentOccupancy.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LiveOccupancy>;
    })
  );
}

getStationCurrentOccupancy.PATH = '/stations/{uid}/occupancy/current';
